<template>
  <div class="wraps">
    <div class="view">
      <div class="view-bottom">
        <div class="view-bottom-left">
          <div class="left_top">
            <el-button v-if="addClassifyBtn" :disabled="!currentId.viewId" type="primary" size="small"
              @click="getAddTree()">
              新建分类
            </el-button>
            <el-button v-if="renameBtn" type="primary" size="small"
              :disabled="!currentId.viewId || currentId.parentId == '0'" @click="getEditTree()">
              编辑
            </el-button>
            <el-button v-if="deleteBtn" class="delete" size="small" type="danger" plain
              :disabled="!currentId.viewId || currentId.parentId == '0'" @click="deleteTree()">
              删除
            </el-button>
          </div>
          <el-tree ref="dicTree" class="dicTree" :data="viewTypeTreeList" highlight-current node-key="viewId"
            :props="defaultProps" current-node-key="1" :default-expanded-keys="defaultExpandedKeys"
            @current-change="currentDicChange">
            <template #default="{ data }">
              <span :title="data.viewName" class="span-ellipsis">
                <img v-if="data.parentId==='0'" :src="carcass_png" alt="视图" />
                <img v-else :src="classify_png" alt="视图分类" />
                <span style="font-size:14px">{{ data.viewName }}
                  {{ data.viewFileNum ? '（' + data.viewFileNum + '）' : '' }}</span>
              </span>
            </template>
          </el-tree>
        </div>
        <div class="view-bottom-middle">
          <div class="middle_top">
            <el-button type="primary" size="small" :disabled="multipleSelection.length===0" @click="batchDownload">
              批量下载
            </el-button>
            <el-input v-model="keyWord" placeholder="请输入模型视图名称" style="float: right; width: 180px" size="small"
              :maxlength="20" clearable @clear="getViewTable(1)" @keyup.enter.native="getViewTable(1)">
            </el-input>
          </div>
          <div class="tableList">
            <el-table ref="viewTable" class="jk-table treeTab" height="100%" size="small" :data="viewTable"
              style="width: 100%" border highlight-current-row row-key="viewFileId" :default-expand-all="true"
              :tree-props="{children: 'childrenList'}" @row-click="clickRow" @selection-change="selectionBatch">
              <el-table-column type="selection" width="55" align="center" reserve-selection />
              <el-table-column label="序号" prop="index" width="60" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.$index + 1 }}</span>
                </template>
              </el-table-column>
              <el-table-column type="expand" prop="children">
                <template slot-scope="scope">
                  <div class="tag-content">
                    <div style="margin-left:170px;width:410px">
                      <el-tree :data="scope.row.children" :props="defaultProps2" default-expand-all :expand-on-click-node="false" highlight-current>
                        <template #default="{ data }">
                          <span :title="data.viewFileName" class="span-ellipsis">
                            <span>{{ data.viewFileName }}</span>
                          </span>
                        </template>
                      </el-tree>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="viewFileName" label="模型视图名称" align="left" show-overflow-tooltip width="410px">
              </el-table-column>
              <el-table-column prop="createVersion" label="软件版本" align="center" show-overflow-tooltip width="140">
                <template #default="{row}">
                  {{ row.createVersion?row.createVersion:'解析中' }}
                </template>
              </el-table-column>
              <el-table-column prop="version" label="版本" align="center" width="120">
                <template #default="{ row }">
                  <el-link type="primary" @click="historyFamily(row)">
                    <span class="tabLinkSpan" :title="row.version">{{ row.version }}</span>
                  </el-link>
                </template>
              </el-table-column>
              <el-table-column prop="operUserName" label="上传人" align="center" show-overflow-tooltip width="120" />
              <el-table-column prop="operDate" label="更新时间" align="center" show-overflow-tooltip width="150" />
              <el-table-column label="操作" align="center">
                <template #default="{ row }">
                  <el-button v-if="editView" type="text" size="small" style="font-size: 18px" @click="getViewFileVisible(row)">
                    编辑
                  </el-button>
                  <el-button v-if="deleteView" type="text" size="small" style="font-size: 18px" @click="deleteViewFile(row)">
                    删除
                  </el-button>
                  <el-button type="text" size="small" style="font-size: 18px" @click="historyFamily(row)">
                    模型历史版本
                  </el-button>
                  <el-button type="text" size="small" style="font-size: 18px" @click="download(row,1)">
                    下载
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="page">
            <el-pagination v-if="page.totalCount > 0" size="small" background :current-page="page.pageNo"
              :page-size="page.pageSize" :page-sizes="[10, 20, 50, 100]" :layout="page.pageLayout"
              :total="page.totalCount" @current-change="familyChangeData" @size-change="handleSizeChange" />
          </div>
        </div>
      </div>
    </div>
    <!-- 添加/编辑分类弹框 -->
    <el-dialog v-dialogDrag :title="viewClassificationTitle" :visible="viewClassificationVisible" width="500px"
      :before-close="viewClassificationVisibleClose" :close-on-click-modal="false" :close-on-press-escape="false">
      <div>
        <el-form ref="treeForm" :model="treeForm" label-width="100px" :rules="rules" size="small">
          <el-form-item label="分类名称" prop="viewName">
            <el-input ref="viewName" v-model.trim="treeForm.viewName" placeholder="请输入名称" :maxlength="20" />
          </el-form-item>
          <el-form-item label="分类编号" prop="viewNum">
            <el-input v-model.trim="treeForm.viewNum" placeholder="请输入分类编号" :maxlength="20" />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="viewClassificationVisibleClose">取 消</el-button>
        <el-button size="small" type="primary" @click="viewTreeSure">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 视图历史版本模态框 -->
    <el-dialog v-if="oldVisible" v-dialogDrag title="模型历史版本" :visible="oldVisible" width="1230px" height="600px"
      :before-close="oldClose" :close-on-click-modal="false" :close-on-press-escape="false">
      <el-table ref="table" class="jk-table" height="500px" size="small" :data="oldData" style="width: 100%"
        highlight-current-row border>
        <el-table-column prop="name" label="模型名称" align="center" show-overflow-tooltip>
          <template #default="{row}">
            <div style="display: flex; align-items: center">
              <rfaFileLightFlag :row="row" @updateLight="uploadBimexOld" />
              <el-link type="primary" @click="openView(row,2)">
                {{ row.name }}
              </el-link>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="createVersion" label="软件版本" align="center" show-overflow-tooltip>
          <template #default="{row}">
            {{ row.createVersion?row.createVersion:'解析中' }}
          </template>
        </el-table-column>
        <el-table-column prop="version" label="版本" align="center" show-overflow-tooltip />
        <el-table-column prop="userName" align="center" label="上传人" show-overflow-tooltip />
        <el-table-column prop="operDate" align="center" label="状态更新时间" show-overflow-tooltip />
        <el-table-column label="操作" align="center" width="200">
          <template #default="{ row }">
            <el-button type="text" size="small" style="font-size: 18px" @click="download(row,2)">
              下载
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <!-- 编辑模型名称 -->
    <el-dialog v-if="fileVisible" v-dialogDrag title="编辑" :visible="fileVisible" width="550px" :before-close="fileClose"
      :close-on-click-modal="false" :close-on-press-escape="false">
      <div>
        <el-form ref="fileForm" :model="fileForm" label-width="90px" :rules="fileFormRules" size="small">
          <el-form-item label="模型名称" prop="viewFileName">
            <el-input v-model.trim="fileForm.viewFileName" placeholder="请输入模型名称" :maxlength="100" show-word-limit />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="fileClose">取 消</el-button>
        <el-button size="small" type="primary" @click="submitUpload">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { downloadFile, downloadUrltoken } from "@/CommonDP/utils";
import routerInit from "@/CommonDP/router";
import { mapState } from "vuex";
import { checkPermission } from "@/CommonDP/utils/routeAuth";
import XtDesignRequest from "@/CommonDP/service/XtDesign-service";
import viewManagementRequest from "@/CommonDP/service/viewManagement-service";
import docService from "@/CommonDP/service/doc-service";
import rfaFileLightFlag from "../familyLibrary/components/rfaFileLightFlag";

export default {
  name: "ViewManagement",
  components: {
    rfaFileLightFlag
  },
  data() {
    return {
      addClassifyBtn: checkPermission(this.$allPerms.VIEWNEWFOLDER),
      renameBtn: checkPermission(this.$allPerms.VIEWRENAME),
      deleteBtn: checkPermission(this.$allPerms.VIEWDELETE),
      editView: checkPermission(this.$allPerms.EDITVIEW),
      deleteView: checkPermission(this.$allPerms.DELETEVIEW),
      carcass_png: require("@/CommonDP/assets/application/familyLibrary/carcass.png"),
      classify_png: require("@/CommonDP/assets/application/familyLibrary/classify.png"),
      defaultExpandedKeys: [], // 默认展开
      viewTypeTreeList: [], // 视图类型树
      viewTable: [], // 视图列表
      currentId: {}, // 目录树选中
      defaultProps: {
        label: "viewName",
        children: "children"
      },
      viewClassificationVisible: false, // 添加弹框
      treeForm: {
        viewName: "",
        viewNum: ""
      },
      rules: {
        viewName: [{ required: true, message: "请输入名称", trigger: "blur" }],
        viewNum: [{ required: true, message: "请输入分类编号", trigger: "blur" }]
      },
      keyWord: "", // 关键词
      viewFileId: "", // 视图id
      page: {
        pageNo: 1,
        pageSize: 20,
        totalCount: 0,
        pageLayout: "total, sizes,prev, pager, next, jumper" // 分页组件
      },
      oldVisible: false, // 历史版本弹框
      oldData: [], // 视图历史版本记录
      newVersionRow: {}, // 上传新版本文件用的数据（行数据）
      viewClassificationTitle: "新建分类",
      trendsPrjId: "",
      currentViewFileId: "",
      tableRow: {},
      timerOld: null, // 定时器
      multipleSelection: [],
      fileVisible: false, // 编辑弹框
      fileForm: {
        type: '',
        createVersion: "",
        viewFileId: "",
        viewFileName: ""
      },
      fileFormRules: {
        viewFileName: [{ required: true, message: "请输入视图名称", trigger: "blur" }]
      },
      defaultProps2: {
        children: 'children',
        label: 'viewFileName'
      }
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId,
      prjId: (state) => state.projectMg.prjObj.prjId,
      userInfo: (state) => state.user.userInfo
    })
  },
  watch: {
  },
  created() {
    this.getViewTree(1).then(() => {
      this.getViewTable();
    });
    this.familyDocByEnterpriseId();
  },
  methods: {
    async familyDocByEnterpriseId() {
      const res = await viewManagementRequest.getViewDocByEnterpriseId(this.enterpriseId);
      this.trendsPrjId = res.data;
    },
    deleteViewFile(val) {
      this.$confirm("此操作将删除此模型视图文件，是否继续？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        closeOnClickModal: false,
        closeOnPressEscape: false
      }).then(async () => {
        await viewManagementRequest.deleteViewFile([val.viewFileId]);
        this.getViewTree().then(() => {
          this.page.pageNo = 1;
          this.getViewTable();
        });
        this.$message({
          showClose: true,
          type: "success",
          message: "删除成功"
        });
      });
    },
    uploadBimexOld(row) {
      if (!this.timerOld) {
        this.timerOld = setInterval(() => {
          this.getOldData(this.newVersionRow);
        }, 14000);
      }
      if (this.isSuccess(row)) {
        this.$confirm("当前文件已轻量化成功,是否重新轻量化?", "提示").then(() => {
          this.updateLight(row, 0);
        });
      } else {
        this.updateLight(row, 0);
      }
    },
    updateLight(row, type) {
      const prjId = this.trendsPrjId;
      row.status = "1";
      const status = row.status;
      let messageType;
      type === 1 ? (messageType = "优先轻量化操作") : (messageType = "重新轻量化操作");
      const fileIds = row.fileId || row.viewFileId;
      docService
        .updateLight(prjId, fileIds, row.version)
        .then((res) => {
          if (res.result === "0") {
            row.status = "1";
            this.$message.success(`${messageType}成功`);
          } else {
            row.status = status;
            this.$message.warning(`${messageType}失败`);
          }
        })
        .catch(() => {
          row.status = status;
          // this.$message.warning(`${messageType}失败`)
        });
    },
    // 预览1
    openView(row, tyep) {
      if (this.isWaiting(row)) {
        this.$message.warning("文件还未轻量化，无法预览");
        return;
      } else if (this.isFail(row)) {
        this.$message.warning("文件轻量化失败，无法预览");
        return;
      } else if (this.isDealing(row)) {
        this.$message.warning("文件轻量化中，无法预览");
        return;
      } else if (this.isSuccess(row)) {
        const { version } = row;
        const fileIds = tyep === 2 ? row.fileId : row.viewFileId;
        const modelParams = { fileIds: fileIds, versionIds: version, noNeedIssue: true };
        this.windowOpen({ path: "/modelpro", query: modelParams });
      }
    },
    isWaiting(row) {
      return row.status === "1" || row.status === "5" || row.status === "99";
    },
    isSuccess(row) {
      return row.status === "2" || row.status === "6";
    },
    isFail(row) {
      return row.status === "3" || row.status === "7";
    },
    isDealing(row) {
      return row.status === "4" || row.status === "8";
    },
    // 预览2
    windowOpen(routeInfo) {
      const router = routerInit();
      const routeUrl = router.resolve(routeInfo);
      window.open(routeUrl.href, "_blank");
    },
    // 打开视图历史弹框
    historyFamily(row) {
      this.newVersionRow = row; // 上传新版本按钮用的行数据
      this.getOldData(row);
      this.oldVisible = true;
    },
    // 分页
    handleSizeChange(val) {
      this.page.pageNo = 1;
      this.page.pageSize = val;
      this.getViewTable();
    },
    // 下载
    download(row, val) {
      const fileId = val === 1 ? row.viewFileId : row.fileId;
      const prjId = this.trendsPrjId;
      const { token } = this.userInfo;
      const downzipurl = val === 1 ? downloadUrltoken(prjId, fileId) : downloadUrltoken(prjId, fileId, row.version);
      downloadFile(downzipurl);
    },
    // 视图类型树
    getViewTree(val) {
      return viewManagementRequest.getViewManagementTree(this.enterpriseId).then(({ data }) => {
        this.viewTypeTreeList = data;
        if (val && data.length) {
          this.currentId = data[0];
        }
        this.defaultExpandedKeys = [this.currentId.viewId];
        this.$nextTick(() => {
          if (this.$refs.dicTree) this.$refs.dicTree.setCurrentKey(this.currentId.viewId);
        });
        this.viewTable = [];
      });
    },
    // 打开新增视图类型弹框
    async getAddTree() {
      this.treeForm.viewName = "";
      this.treeForm.viewNum = "";
      this.viewClassificationTitle = "新建分类";
      this.viewClassificationVisible = true;
      await this.$nextTick();
      this.$refs.viewName.focus();
      this.$refs.treeForm.clearValidate();
    },
    // 打开重命名弹框
    async getEditTree() {
      this.treeForm.viewName = this.currentId.viewName;
      this.treeForm.viewNum = this.currentId.viewNum;
      this.viewClassificationTitle = "编辑分类";
      this.viewClassificationVisible = true;
      await this.$nextTick();
      this.$refs.treeForm.clearValidate();
    },
    // 打开修改视图弹框
    async getViewFileVisible(row) {
      this.fileForm.type = row.type;
      this.fileForm.createVersion = row.createVersion;
      this.fileForm.viewFileId = row.viewFileId;
      this.fileForm.viewFileName = row.viewFileName.slice(0, -4);
      this.fileVisible = true;
      await this.$nextTick();
      this.$refs.fileForm.clearValidate();
    },
    // 关闭添加弹框
    viewClassificationVisibleClose() {
      this.viewClassificationVisible = false;
    },
    // 历史版本视图弹框关闭
    oldClose() {
      clearInterval(this.timerOld);
      this.timerOld = null;
      this.oldVisible = false;
    },
    // 添加视图类型
    viewTreeSure() {
      this.$refs.treeForm.validate(async (valid) => {
        if (!valid) return;
        if (this.viewClassificationTitle === "新建分类") {
          this.addViewTree();
        } else {
          this.editViewTree();
        }
      });
    },
    // 添加视图分类
    addViewTree() {
      const { viewName, viewNum } = this.treeForm;
      const params = {
        enterpriseId: this.enterpriseId,
        parentId: this.currentId.viewId,
        viewName,
        viewNum
      };
      viewManagementRequest.addViewManagement(params).then(() => {
        this.getViewTree().then(() => {
          this.page.pageNo = 1;
          this.getViewTable();
        });
        this.viewClassificationVisible = false;
        this.$message({
          type: "success",
          message: "添加成功"
        });
      });
    },
    // 修改视图分类
    editViewTree() {
      const params = {
        enterpriseId: this.enterpriseId,
        viewId: this.currentId.viewId,
        viewName: this.treeForm.viewName,
        viewNum: this.treeForm.viewNum
      };
      viewManagementRequest.updateViewManagement(params).then(() => {
        this.viewClassificationVisible = false;
        this.getViewTree(1).then(() => {
          this.page.pageNo = 1;
          this.getViewTable();
        });
        this.$message({
          type: "success",
          message: "修改成功"
        });
      });
    },
    // 删除视图类型
    deleteTree() {
      this.$confirm("此操作将删除此视图类型，是否继续？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        closeOnClickModal: false,
        closeOnPressEscape: false
      }).then(async () => {
        await viewManagementRequest.deleteViewManagement(this.currentId.viewId);
        this.currentId = {};
        this.getViewTree(1).then(() => {
          this.page.pageNo = 1;
          this.getViewTable();
        });
        this.$message({
          showClose: true,
          type: "success",
          message: "删除成功"
        });
      });
    },
    // 表格数据
    getViewTable(val) {
      const { pageSize, pageNo } = this.page;
      const param = {
        enterpriseId: this.enterpriseId,
        pageNum: val || pageNo,
        pageSize,
        viewId: this.currentId.viewId ? this.currentId.viewId : 1,
        viewFileName: this.keyWord
      };
      viewManagementRequest.getViewFile(param).then(({ data, totalCount, pageIndex }) => {
        this.page.pageNo = pageIndex;
        this.page.totalCount = totalCount;
        this.viewTable = data;
        this.currentViewFileId = '';
        this.tableRow = {};
        if (data[0]) {
          this.clickRow(data[0]);
        }
      });
    },
    // 视图表格分页点击
    familyChangeData(val) {
      this.page.pageNo = val;
      this.getViewTable();
    },
    // 获取历史版本数据
    async getOldData(val) {
      const res = await XtDesignRequest.queryBaseProperty(val.viewFileId, 0, "");
      this.oldData = res.data;
    },
    // 点击视图列表的某一行
    clickRow(row) {
      // 获取属性
      this.tableRow = row;
      this.currentViewFileId = row.viewFileId;
    },
    // 选中目录树
    currentDicChange(val) {
      this.currentId = val;
      this.viewTable = [];
      this.page.pageNo = 1;
      this.$refs.viewTable.clearSelection();
      this.getViewTable();
    },

    selectionBatch(val) {
      this.multipleSelection = val;
    },
    // 编辑
    submitUpload() {
      this.$refs.fileForm.validate(async (valid) => {
        if (!valid) return;
        const params = {
          rvtVersion: this.fileForm.createVersion,
          type: this.fileForm.type,
          viewFileId: this.fileForm.viewFileId,
          viewFileName: this.fileForm.viewFileName + ".rvt",
          viewId: this.currentId.viewId
        };
        await viewManagementRequest.updateFamilyRecord(params);
        this.fileVisible = false;
        this.page.pageNo = 1;
        this.getViewTable();
        this.$message({
          message: "修改成功",
          type: "success"
        });
      });
    },
    // 编辑族弹框关闭
    fileClose() {
      this.fileVisible = false;
    },
    // 批量下载
    batchDownload() {
      const prjId = this.trendsPrjId;
      const fileId = this.multipleSelection.map(item => item.viewFileId);
      const urls = fileId.map(item => {
        return downloadUrltoken(prjId, item);
      });
      for (let i = 0; i < urls.length; i++) {
        downloadFile(urls[i]);
      }
    }

  }
};
</script>

<style lang="scss" scoped>
.wraps {
  width: 100%;
  height: 100%;
  padding: 14px;
  .view {
    width: 100%;
    height: 100%;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    background-color: #eff1f6;
    .view-bottom {
      flex: 1;
      display: flex;
      overflow: hidden;
    }
  }
  .view-bottom-left {
    overflow: hidden;
    padding-top: 5px;
    display: flex;
    flex-direction: column;
    width: 264px;
    border-right: 1px solid #f2f2f2;
    background-color: #fff;
    .left_top {
      display: flex;
      padding: 14px;
      border-bottom: 1px solid #e5e8f1;
      .el-button + .el-button {
        margin-left: 10px;
      }
    }
    .dicTree {
      overflow: auto;
      flex: 1;
      font-size: 14px;
      padding-top: 15px;
      img {
        margin-right: 6px;
      }
      .span-ellipsis {
        width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        display: flex;
        align-items: stretch;
      }
    }
  }
  .view-bottom-middle {
    overflow: hidden;
    flex: 1;
    padding-top: 5px;
    border-right: 1px solid #f2f2f2;
    display: flex;
    flex-direction: column;
    margin-left: 10px;
    background-color: #fff;
    .middle_top {
      padding: 14px;
      border-bottom: 1px solid #e5e8f1;
    }
    .tableList {
      flex: 1;
      overflow: hidden;
      padding: 15px 15px 0 15px;
      .jk-table{
        /deep/ .el-tree-node__expand-icon{
          display: none;
        }
        /deep/ .el-tree-node__content:hover{
          background-color:#FFF
        }
        /deep/ .el-tree-node__content:active{
          background-color:#FFF
        }
        /deep/ .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content{
          background-color:#FFF
        }
        /deep/ .el-tree-node__content{
          height:20px !important;
          cursor:auto;
        }
      }
      ::v-deep(.el-table__row:not([class*="el-table__row--level-"])) {
        td:nth-of-type(2){
          padding-left: 22px;
        }
      }
    }
    .page {
      width: 100%;
      height: 45px;
      margin: 8px auto;
      display: flex;
      justify-content: flex-end;
      .el-pagination {
        float: right;
      }
    }
  }
  .span-ellipsis {
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
</style>
